import { FileType } from '@alucio/aws-beacon-amplify/src/models';
import { ContentPageData } from 'src/hooks/useContentPageData/useContentPageData';

interface MultiPageHtmlPageDataOptions {
  contentType?: FileType | string;
  documentVersionId?: string;
  isMultiPageHTML?: boolean;
  expectedPageCount?: number;
  contentPageData?: ContentPageData[];
  isDocumentTransitionWithExistingContent?: boolean;
}

export function shouldWaitForMultiPageHtmlPageData({
  contentType,
  documentVersionId,
  isMultiPageHTML,
  expectedPageCount,
  contentPageData = [],
  isDocumentTransitionWithExistingContent = false,
}: MultiPageHtmlPageDataOptions): boolean {
  if (
    !documentVersionId ||
    contentType !== FileType.HTML ||
    !isMultiPageHTML ||
    !expectedPageCount ||
    expectedPageCount <= 1
  ) {
    return false;
  }

  if (contentPageData.length === 0) {
    return isDocumentTransitionWithExistingContent;
  }

  const currentDocumentPageData = contentPageData.filter((page) =>
    page.pageId.startsWith(`${documentVersionId}_`),
  );

  return currentDocumentPageData.length < expectedPageCount ||
    currentDocumentPageData.some((page) => !page.htmlUrl);
}
